export default __webpack_public_path__ + "static/media/upload_plan.5b364b3b.svg";